export default __webpack_public_path__ + "static/media/yellow-feather.27641dbb.png";